

import myComputer from "../../assets/mycomputer.png";
import myDocuments from "../../assets/myDocuments.png";
import tree from "../../assets/tree.png";
import iexplorer from "../../assets/iexplorer.png";
import mspaint from "../../assets/mspaint.png";
import msdocument from "../../assets/msdocument.png";
import minesweeper from "../../assets/minesweeper.png";
import bin from "../../assets/bin.png";


import GeneralModal from "../modal/GeneralModal";
import {appArray} from "../../App";
import React from "react";
import ModalFactory from "../modal/ModalFactory";


function DesktopIcons() {
  return (
    <div className="98desktop" style={desktopIconsStyle.root}>
    {appArray.map((app) => (
        DesktopIcon(app, (id) => {
            ModalFactory.toggleModal(id);
        })
    ))}
    </div>
  );
}

function DesktopIcon(app : {name: string, icon: string, id: string}, iconClicked: (id: string) => void): JSX.Element {
  return (
    <button style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      margin: '10px 0', padding: '5px', background: 'none', boxShadow: 'none',
      width: '150px', height: '100px', cursor: 'pointer'
    }} onClick={() => iconClicked(app.id)}>
        <img src={app.icon} alt="desktopIcon" draggable={false} style={{height: '70%', marginBottom: '10px'}}/>
        <b style={{color: 'white', fontSize: '1.3em'}} className="">{app.name}</b>
    </button>
  );
}

const desktopIconsStyle = {
  root: {
    display: "flex",
    flexWrap: "wrap" as "wrap",
    flexDirection: "column" as "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    alignContent: "flex-start",

    height: "100%",
    padding: "20px",

    userSelect: "none" as "none",
  }

};

export default DesktopIcons;
